module.exports = __webpack_public_path__ + "static/media/sell_question_1.54ceec20.jpg";